import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { StaffService } from 'src/app/core/api/staff.service';
import { LanguageCode } from 'src/app/translations/language.model';
import { TranslationsService } from './../../translations/translations.service';

@Component({
  selector: 'csi-select-language-modal',
  templateUrl: './select-language-modal.component.html',
  styleUrls: ['./select-language-modal.component.css']
})
export class SelectLanguageModalComponent implements OnInit, OnDestroy {
  public currentSelectedLanguage: string = LanguageCode.en;

  public preferredLanguage: string = LanguageCode.en;

  constructor(
    public translationsService: TranslationsService,
    private dialogRef: MatDialogRef<SelectLanguageModalComponent>,
    private staffService: StaffService
  ) {}

  ngOnInit() {
    const staffLang = this.staffService.staff && this.staffService.staff.preferredLanguage;

    // use staff preference if set, otherwise fall back
    this.currentSelectedLanguage = staffLang || LanguageCode.en;

    // keep TranslationsService in sync
    this.translationsService.currentSelectedLanguage = this.currentSelectedLanguage as LanguageCode;

    if (!staffLang) {
      this.staffService
        .updateDoctor({
          id: this.staffService.staff.id,
          preferredLanguage: this.currentSelectedLanguage
        })
        .subscribe(updatedDoctor => {
          this.staffService.staff = updatedDoctor;
        });
    }

    this.dialogRef
      .backdropClick()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.dialogRef.close('');
      });
  }

  ngOnDestroy(): void {}

  public static open(matDialogService: MatDialog) {
    return matDialogService.open(SelectLanguageModalComponent, {
      maxWidth: '90vw',
      data: {}
    });
  }

  selectLanguage(lang: LanguageCode) {
    this.currentSelectedLanguage = lang;

    this.translationsService.currentSelectedLanguage = lang;
    this.translationsService.changeLanguage(lang);

    this.staffService.staff = {
      ...this.staffService.staff,
      preferredLanguage: lang
    };

    this.dialogRef.close(this.currentSelectedLanguage);

    this.staffService
      .updateDoctor({
        id: this.staffService.staff.id,
        preferredLanguage: lang
      })
      .subscribe(updatedDoctor => {
        this.staffService.staff = updatedDoctor;
      });
  }

  public noSort() {
    return 0;
  }
}
